import { render, staticRenderFns } from "./BlogAuthorHero.vue?vue&type=template&id=90b6d02c&"
import script from "./BlogAuthorHero.vue?vue&type=script&lang=js&"
export * from "./BlogAuthorHero.vue?vue&type=script&lang=js&"
import style0 from "./BlogAuthorHero.vue?vue&type=style&index=0&id=90b6d02c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports